import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DropDownMenuBase from 'frontcore/views/drop-down/views/base/DropDownMenuBase.vue'
import DropDownMenuItem from 'frontcore/views/drop-down/views/unit/DropDownMenuItem.vue'
import {
  DropDownDirection,
  DropDownMenuItemProps,
} from "frontcore/views/drop-down/domain/types"

interface Props {
  value: DropDownMenuItemProps['id'][]
  optionList: DropDownMenuItemProps[]
  direction?: DropDownDirection
  keepOrder?: boolean
}
type Emits = (e: 'input:value', value: Props['value']) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownMenuMultipleSelection',
  props: {
    value: {},
    optionList: {},
    direction: { default: DropDownDirection.LEFT },
    keepOrder: { type: Boolean, default: false }
  },
  emits: ["input:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const onClickOption = (id: DropDownMenuItemProps['id']) => {
  let newValues: Props['value'] = []
  if (props.value.includes(id)) {
    newValues = props.value.filter(val => val !== id)
  } else {
    newValues = [...props.value, id]
  }
  emit('input:value', newValues)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DropDownMenuBase, {
    optionList: _ctx.optionList,
    direction: _ctx.direction,
    keepOrder: _ctx.keepOrder
  }, {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header")
    ]),
    item: _withCtx(({ item }) => [
      _createVNode(DropDownMenuItem, {
        id: item.id,
        selected: _ctx.value.includes(item.id),
        dataTest: item.dataTest || `dropdown-option-${item.id}`,
        iconColorClass: item.iconColorClass,
        disabled: item.disabled,
        iconName: item.iconName,
        imageSrc: item.imageSrc,
        text: item.text,
        multiple: "",
        onOnClickOption: onClickOption
      }, null, 8, ["id", "selected", "dataTest", "iconColorClass", "disabled", "iconName", "imageSrc", "text"])
    ]),
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _: 3
  }, 8, ["optionList", "direction", "keepOrder"]))
}
}

})